module.exports = __webpack_public_path__ + "img/discord.4e43caca.png";